import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';

import { ChangePasswordComponent } from '../../login/change-password/change-password.component';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../services/common-service';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService } from '../../services/toast-service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-profile-icon',
  imports: [
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    CommonModule,
    FormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule

  ],
  standalone: true,
  templateUrl: './profile-icon.component.html',
  styleUrl: './profile-icon.component.scss'
})
export class ProfileIconComponent implements OnInit {
  isMenuOpen = false;
  dialogRef: MatDialogRef<ChangePasswordComponent> | undefined;
  is2FA: any = ''
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  @ViewChild('socialMediaModal') socialMediaModal!: TemplateRef<any>;
  @ViewChild('profileModal') profileModal!: TemplateRef<any>;
  disable2FAReason: any = '';
  profileName: any = sessionStorage.getItem('name')?.replaceAll('"', '') || 'User';
  socialMediaType: any = null
  enableSocialLogin: any = 'enable'
  email: any = sessionStorage.getItem('email')?.replaceAll('"', '') || ''
  userId: any = sessionStorage.getItem('userId')?.replaceAll('"', '') || ''
  mobile: any = sessionStorage.getItem('mobile')?.replaceAll('"', '') || ''

  constructor(private commonService: CommonService, private matDialog: MatDialog, public toast: ToastService, public router: Router) {
  }

  ngOnInit(): void {

    this.is2FA = sessionStorage.getItem('is2FA')
    console.log('is2FA', this.is2FA);
    // Initialization logic if needed
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  listofReportsIssues: any = []
  reportIssue: any = ''

  onMenuClick(event: any): void {
    switch (event) {
      case 'profile':
        // this.dialogRef = this.matDialog.open(this.profileModal, {});
      this.router.navigate(['/home/user-profile'])

        break;
      case 'password':
        this.matDialog.open(ChangePasswordComponent, {
          data: { /* pass any data if needed */ }
        });
        break;
      case 'social':
        this.dialogRef = this.matDialog.open(this.socialMediaModal, {});
        break;
      case '2fa':
        if (this.is2FA === 'Yes') {
          // this.getReportIssue()
          this.dialogRef = this.matDialog.open(this.modalContent, {
            data: { action: 'disable2fa' }
          });
        } else {
          this.dialogRef = this.matDialog.open(this.modalContent, {
            data: { action: 'enable2fa' }
          });
        }
        break;
      case 'logout':
        this.onLogout();
        break;
      default:
        break;
    }
    this.closeMenu();
  }

  onLogout() {
    this.commonService.callGetAPI('/auth/logout').subscribe({
      next: (res: any) => {
        if (res) {
          console.log(res)
          this.toast.showSuccess(res.message || 'Logged out successfully');
          sessionStorage.clear();
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 500);
        }
      },
      error: (err: any) => {
      }
    });
  }

  saveSocialSettings() {
    this.commonService.callGetAPI(`/auth/${this.enableSocialLogin == 'enable' ? 'social-media-registration' : 'disable-social-media'}/${this.socialMediaType}/${sessionStorage.getItem('userId')}`).subscribe(
      (resp: any) => {
        debugger
        console.log(resp)
        if (this.enableSocialLogin == 'enable' && resp) {
          window.open(resp.redirectTo)
        }
      }
    );
  }

  getReportIssue() {
    this.commonService.callGetAPI('/auth/disable-2fa').subscribe({
      next: (res: any) => {
        this.listofReportsIssues = res?.data || [];
        this.dialogRef = this.matDialog.open(this.modalContent, {
          data: { action: 'disable2fa' }
        });
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  closeModal(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  show2FARegistrationModal: boolean = false
  qrCodeImage: string = '';


  on2FAModalAction(action: string): void {
    debugger
    if (action === 'enable2fa') {
      this.commonService.callGetAPI('/auth/enable-2fa').subscribe({
        next: (res: any) => {
          console.log('2FA enabled successfully');
          this.qrCodeImage = res?.data?.image_base64 || '';
          this.show2FARegistrationModal = true
          sessionStorage.setItem('is2FA', "Yes");
          this.is2FA = sessionStorage.getItem('is2FA')

        },
        error: (err: any) => {
          console.error('Error enabling 2FA:', err);
        }
      });
    } else if (action === 'disable2fa') {
      this.commonService.callPostAPI('/auth/disable-2fa', { reason: "Disabled" }).subscribe({
        next: (res: any) => {
          console.log('2FA disabled successfully');
          sessionStorage.setItem('is2FA', "No");
          this.is2FA = sessionStorage.getItem('is2FA')
          this.closeModal();
          this.onLogout();

        },
        error: (err: any) => {
          console.error('Error disabling 2FA:', err);
          this.disable2FAReason = err?.error?.message || 'Unknown error';
        }
      });
    }
  }

  proceedTo2FAVerification() {
    this.show2FARegistrationModal = false;
    this.closeModal()
    this.onLogout();
  }

}
